import { fitFontPx } from './fitFontPx';

export function guidelineNames(mergeIds) {
    return (mergeIds || [])
        .map(item => (typeof item === 'string' ? item : item?.name))
        .map(name => String(name || '').trim())
        .filter(Boolean);
}

function escapeHtml(value) {
    return String(value).replace(/[&<>"']/g, ch => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[ch]));
}

/**
 * One A4 page per name. Text is centered and sized to the largest font that
 * still fits inside 80% of the page. Uses the browser print dialog
 * (Save as PDF / printer). ponytail: no PDF library; upgrade path is pdf-lib
 * if a file download without a dialog is required.
 */
export function printRackLabels(names) {
    const labels = (names || []).map(name => String(name || '').trim()).filter(Boolean);
    if (!labels.length) return false;

    const pages = labels
        .map(name => `<section class="sheet"><div class="label">${escapeHtml(name)}</div></section>`)
        .join('');

    const win = window.open('', '_blank');
    if (!win) return false;

    win.document.open();
    win.document.write(`<!doctype html>
<html>
<head>
<meta charset="utf-8" />
<title>Rack Labels</title>
<style>
  @page { size: A4 portrait; margin: 0; }
  html, body { margin: 0; padding: 0; }
  .sheet {
    width: 210mm;
    height: 297mm;
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: hidden;
    break-after: page;
    page-break-after: always;
  }
  .sheet:last-child { break-after: auto; page-break-after: auto; }
  .label {
    width: max-content;
    max-width: 80%;
    font-family: Arial, Helvetica, sans-serif;
    font-weight: 700;
    line-height: 1.05;
    text-align: center;
    overflow-wrap: anywhere;
    word-break: break-word;
  }
</style>
</head>
<body>${pages}</body>
</html>`);
    win.document.close();

    let printed = false;
    const fit = () => {
        if (printed) return;
        const sheets = [...win.document.querySelectorAll('.sheet')];
        if (!sheets.length || !sheets[0].clientWidth) return;
        printed = true;
        sheets.forEach(sheet => {
            const label = sheet.querySelector('.label');
            const maxW = sheet.clientWidth * 0.8;
            const maxH = sheet.clientHeight * 0.8;
            label.style.maxWidth = `${maxW}px`;
            const px = fitFontPx(size => {
                label.style.fontSize = `${size}px`;
                const rect = label.getBoundingClientRect();
                return rect.width <= maxW + 1 && rect.height <= maxH + 1;
            });
            label.style.fontSize = `${px}px`;
        });
        win.onafterprint = () => win.close();
        win.focus();
        win.print();
    };

    fit();
    win.addEventListener('load', fit);
    setTimeout(fit, 100);

    return true;
}
